import { useSyncExternalStore } from "react";

/** A phone, in the kit's one breakpoint for it: below 768 px (the tab bar replaces the rail there). */
export const PHONE_QUERY = "(max-width: 767px)";

/** Whether a media query matches, now and after every change (a resize, a rotated phone). Read during render, so the first paint is right. */
export function useMedia(query: string): boolean {
  return useSyncExternalStore(
    (onChange) => { const m = window.matchMedia(query); m.addEventListener("change", onChange); return () => m.removeEventListener("change", onChange); },
    () => window.matchMedia(query).matches,
    () => false,
  );
}
